import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

import { CanopyState } from "./types";

const state = {} as CanopyState;

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
